import React, {useState, useEffect} from 'react';
import './App.css';
import {MapContainer, TileLayer, Marker, Popup} from 'react-leaflet';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';
import pfp from './assets/pfp.png';

// get stores
import {data} from './stores';

// import marker icons
import markerIcon from 'leaflet/dist/images/marker-icon.png';
import markerShadow from 'leaflet/dist/images/marker-shadow.png';
let DefaultIcon = L.icon({iconUrl: markerIcon, shadowUrl: markerShadow});
L.Marker.prototype.options.icon = DefaultIcon;

function App() { // app component
  const [stores, setStores] = useState(data);
  const [currentView, setCurrentView] = useState('home');
  const [selectedCity, setSelectedCity] = useState('Boston');

  // useEffect(() => {
  //   fetch('http://localhost:5001/api/stores') 
  //     .then(response => response.json())
  //     .then(data => setStores(data));
  // }, []);

  return (
    <div style={{fontFamily: 'sans-serif', padding: '20px'}}>
      <nav style={{display: 'flex', justifyContent: 'space-between', marginBottom: '40px'}}>
        <h1 style={{margin: 0, color: '#195c22'}}>revolve</h1> 
        <div>
          <a href="#home" onClick={() => setCurrentView('home')} style={{margin: '0 15px', color: '#195c22', cursor: 'pointer', textDecoration: 'none'}}>home</a>
          <a href="#events" onClick={() => setCurrentView('events')} style={{margin: '0 15px', color: '#195c22', cursor: 'pointer', textDecoration: 'none'}}>events</a>
          <a href="#outfits" onClick={() => setCurrentView('outfits')} style={{margin: '0 15px', color: '#195c22', cursor: 'pointer', textDecoration: 'none'}}>outfits</a>
          <a href="#profile" onClick={() => setCurrentView('profile')} style={{margin: '0 15px', color: '#195c22', cursor: 'pointer', textDecoration: 'none'}}>profile</a>
        </div>
      </nav>

      {currentView === "home" ? (
        <>
          <div style={{height: '400px', width: '70%', maxWidth: '800px', overflow: 'hidden', border: '5px solid #195c22', boxShadow: '0 4px 12px rgba(0, 0, 0, 0.05)', margin: '0 auto 40px'}}>
            <MapContainer center={[42.3736, -71.1097]} zoom={13} style={{ height: '100%', width: '100%' }}>
              <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
              {stores.map(store => (
                <Marker key={store.id} position={[store.lat, store.lang || store.long]}>
                  <Popup><strong>{store.name}</strong> <br /> {store.city}</Popup>
                </Marker>
              ))}
            </MapContainer>
          </div>
          <h2>your favorite vintage stores</h2>
          <div style={{display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '20px'}}>
            {stores.map(store => (
              <div key={store.id} className="store-card" style={{ border: '1px solid #ddd', padding: '15px', borderRadius: '8px', position: 'relative'}}>
                <span style={{position: 'absolute', top: '15px', right: '15px', fontSize: '24px', fontWeight: 'bold', color: '#333'}}>
                  {store.rating}
                </span>
                <h3>{store.name}</h3>
                <p>{store.city}</p>
                <p>{store.price}</p> 
              </div>
            ))}
          </div>
        </>
      ) : currentView === "events" ? (
        // dropdown for events
        <div style={{textAlign: 'center', padding: '50px'}}>
          <h2 style={{fontSize: '32px', marginBottom: '30px'}}>upcoming events in...</h2>
          <select 
            value={selectedCity}
            onChange={(e) => setSelectedCity(e.target.value)}
            style={{ 
              width: '100%', 
              maxWidth: '600px', 
              padding: '20px',
              fontSize: '24px', 
              borderRadius: '12px', 
              border: '3px solid #195c22' 
            }}
          >
            <option value="Boston">Boston</option>
            <option value="Philadelphia">Philadelphia</option>
            <option value="New York">New York</option>
          </select>
          {selectedCity === "Boston" ? (
            <div style={{marginTop: '30px', textAlign: 'center'}}>
              <h3 style={{marginTop: '20px'}}>Select Winter Thrift Market</h3>
              <p> Dates 📆: January 24th and February 1st</p>
              <p> Time ⏰: Paid Early Bird 11am-12pm, Free General Entry 12pm-5pm </p>
              <p> Location 📍: Cyclorama, 539 Tremont St. Boston, MA 02116 </p>

              <h3 style={{marginTop: '40px'}}>SOWA Vintage Market</h3>
              <p> Dates 📆: Every Sunday</p>
              <p> Time ⏰: 11am-5pm </p>
              <p> Location 📍: 450 Harrison Ave, Boston, MA 02118 </p>
            </div>
          ) : selectedCity === "Philadelphia" ? (
            <div style={{marginTop: '30px', textAlign: 'center'}}>
              <h3 style={{marginTop: '20px'}}>The Philly Vintage Flea</h3>
              <p> Dates 📆: March 29th</p>
              <p> Time ⏰: Paid Early Bird 10am-12pm, Free General Entry 12pm-5pm </p>
              <p> Location 📍: Greater Philadelphia Expo Center, 100 Station Ave, Hall C, Oaks, Pennsylvania 19456 </p>
            </div>
          ) : (
            <div style={{marginTop: '30px', textAlign: 'center'}}>
              <h3 style={{marginTop: '20px'}}>Manhattan Vintage Show</h3>
              <p> Dates 📆: January 30th to February 1st</p>
              <p> Time ⏰: 12pm-6pm </p>
              <p> Location 📍: Metropolitan Pavilion, 125 West 18th Street, New York, NY 10011 </p>
            </div>
          )}
        </div>
      ) : currentView == "profile" ? (
        <div style={{textAlign: 'center', padding: '50px'}}>
          <img src={pfp} alt="Profile Picture" style={{width: '250px'}} />
          <h1 style={{marginBottom: '0px'}}>Gracie Yang</h1>
          <h3 style={{marginTop: '7px'}}>23 vintage store visits</h3>
          <p style={{textAlign: 'center', margin: '20px auto', width: '1000px'}}>Hi! I'm Gracie, a sophomore at Penn studying Digital Media Design. 
            I love exploring the intersection of design and engineering, and hope to continue to do so with Penn Spark! 
            In my free time, I also love to thrift, watch movies, bake, and play soccer.</p>
        </div>
      ) : (
        <div style={{textAlign: 'center', padding: '50px'}}>
          <h2>outfits coming soon!</h2>
        </div>
      )}
    </div>
  );
}

export default App;
